import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('interessiMarketing');
export const actions = helper.createActions('interessiMarketing', actionTypes);